import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SaveUserReqVM } from '../../models/api/user.model';
import { apiConfig } from '../../../../../environments/api.config';
import { APIHeaderVM, APIResponseVM } from '../../models/common/common.model';
import { ActionTypeEnum } from '../../enums/common.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TZDStoreUserService {

  public isOpenMenu: boolean = false;
  headerData:any = {};

  constructor(private http: HttpClient) {}

  save_user_business_partner(payload:SaveUserReqVM): Observable<APIResponseVM<any>>{
    const url = apiConfig.tZDStoreUser.save_user_business_partner;
    return this.http.post<APIResponseVM<any>>(url,payload);
  }

  get_common_request(){
    const url = apiConfig.tZDStoreUser.get_common_request;
    return this.http.post(url,{clientKey: environment.clientKey});
  }
}
